import Image from 'next/image'

import type { ImageListBlock as TImageListBlock } from '@/payload-types'

export const ImageListBlock = ({ images }: TImageListBlock) => {
  return (
    <div className="mt-[max(5rem,calc(100dvh-60rem))] items-center w-full justify-self-center justify-center flex flex-col md:flex-row gap-8 md:gap-12">
      {images.map((img) => (
        <Image
          key={img}
          src={`/img/logo/partners/${img}.webp`}
          alt={img.replace('_', '')}
          className="w-[min(60dvw,20dvh)] md:w-[min(15dvw,45dvh)]"
          width={300}
          height={300}
          quality={90}
          sizes="(max-width: 768px) 30vw, 15vw"
        />
      ))}
    </div>
  )
}
